import React from "react";
import { Benefit, BenefitTitle } from "./benefitStyle";

const Benefits = () => {
  return (
    <Benefit>
      <BenefitTitle>
        BENEFITS <strong>&</strong> UTILITIES
      </BenefitTitle>
    </Benefit>
  );
};

export default Benefits;
